import React, { useState } from "react";
import { Modal } from "react-bootstrap";

const WelcomeTour = ({ show, onFinish }) => {
  const [currentStep, setCurrentStep] = useState(0); // Start at 0 for intro page
  const totalSteps = 10; // Now 10 steps total (intro + 9)

  const nextStep = () => {
    if (currentStep < totalSteps - 1) {
      setCurrentStep(currentStep + 1);
    }
  };

  const prevStep = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  const startTour = () => {
    setCurrentStep(1); // Skip directly to first tour step
  };

  const getStepTitle = (step) => {
    switch(step) {
      case 1: return "🌿 Plant a Seed, Grow a Legacy";
      case 2: return "📈 Experience Blooms";
      case 3: return "🎋 Grow Your Forest, Earn Green cred";
      case 4: return "🥇 Climb the Canopy, Top the Leaderboard";
      case 5: return "🔍 Explore the World, One Seed at a Time";
      case 6: return "🌲🌳 The Forest Flourishes, Together";
      case 7: return "🤝 Meet the Newest Sproutlings";
      case 8: return "🤚 Don't miss your place";
      case 9: return "🗺️ Navigate virtual forests";
      default: return "";
    }
  };

  const getStepDescription = (step) => {
    switch(step) {
      case 1: return "This vibrant button lets you plant a virtual tree and contribute to real-world reforestation efforts, Plus, keep an eye out for new trees to plant – they might just sprout up!";
      case 2: return "Track your progress here! See the number the impact you've made on the environment.";
      case 3: return "This button is your gateway to earning experience points (XP) – the more you participate, the greener your TANNIT profile becomes!";
      case 4: return "See how you stack up against other tree-planting enthusiasts! Check the leaderboard to see who's at the top and strive to become the ultimate champion of the forest.";
      case 5: return "Zoom in, zoom out, and navigate this interactive map to explore the locations where your trees are making a difference";
      case 6: return "Here you'll find the ever-growing count of trees planted by the entire TANNIT community, alongside the number of people who have joined the movement. Witness the collective power of making a change!";
      case 7: return "Get inspired by the latest TANNIT members who are joining the cause. See who's planting trees and making the world a greener place!";
      case 8: return "This button is your gateway back to the main Tannit platform. Let's branch out and see what else grows there!";
      case 9: return "We have here a list that lets you explore and plant trees in various virtual forests representing different ecosystems";
      default: return "";
    }
  };

  const renderStepContent = () => {
    if (currentStep === 0) {
      return (
        <div className="text-center d-flex flex-column">
          <img 
            src="/assets/images/ecovestwelcomeimg/tour0.png" 
            alt="Tour Introduction" 
            className="img-fluid mb-4 w-100 image-tour-0"
            style={{ maxHeight: '300px' }}
          />
          <img class="d-flex logo-tour mx-autod-flex align-self-center mt-5 pt-5 logo-tour mx-auto justify-content-center" alt="Logo mark" src="/assets/images/ecovestonboarding/LogoEcovest.png" />
          <div className="text-center">
            <h5 className="mb-3">Take a quick tour and get a head start!</h5>
            <h3 className="text-tour-0">Unlock Your Forest Journey (with a Bonus Sprout!)</h3>
          </div>
          <div className="d-flex flex-column justify-content-center align-items-center gap-3 mt-4 p-3">
            <button 
              className="btn next-button py-3 w-75" 
              onClick={nextStep}
              style={{ backgroundColor: '#6CA63C', borderColor: '#6CA63C' }}
            >
              Take a tour
            </button>
            <button 
              className="btn previous-button py-3 w-75" 
              onClick={onFinish}
            >
              I'll explore by myself
            </button>
          </div>
        </div>
      );
    }

    return (
      <>
        {/* Progress Bar - only show after intro */}
        {currentStep > 0 && (
          <div className="progress mt-3 mb-4" style={{ height: '4px', backgroundColor: '#EAEBEE' }}>
            <div 
              className="progress-bar" 
              role="progressbar" 
              style={{ 
                width: `${(currentStep / (totalSteps - 1)) * 100}%`, 
                backgroundColor: '#6CA63C' 
              }} 
              aria-valuenow={currentStep} 
              aria-valuemin="1" 
              aria-valuemax={totalSteps - 1}
            />
          </div>
        )}
        
        {/* Description */}
        <p className="mb-4">{getStepDescription(currentStep)}</p>
        
        {/* Screenshot - only show after intro */}
        {currentStep > 0 && (
          <div className="text-center">
            <img 
              src={`/assets/images/ecovestwelcomeimg/tour${currentStep}.png`} 
              alt={`Step ${currentStep}`} 
              className="img-fluid rounded"
              style={{ maxHeight: '300px', border: '1px solid #EAEBEE' }}
            />
          </div>
        )}
      </>
    );
  };

  return (
    <Modal show={show} onHide={onFinish} centered size="lg">
      <Modal.Header className={`border-0 ${currentStep === 0 ? 'p-0' : 'pb-0'}`}>
        <div className="d-flex justify-content-between w-100 align-items-center">
          <div className="d-flex align-items-center">
            <Modal.Title>{getStepTitle(currentStep)}</Modal.Title>
          </div>
          {currentStep > 0 && (
            <button 
              type="button" 
              className="btn-close" 
              onClick={onFinish}
              aria-label="Close"
            />
          )}
        </div>
      </Modal.Header>
      <Modal.Body className={`border-0 ${currentStep === 0 ? 'px-0 pt-0' : 'pt-0'}`}>
        {renderStepContent()}
      </Modal.Body>
      {currentStep > 0 && (
        <Modal.Footer className="border-0 d-flex justify-content-between">
          <div className="text-muted">
            {currentStep}/{totalSteps - 1}
          </div>
          <div>
            {currentStep > 1 && (
              <button className="btn me-2 previous-button" onClick={prevStep}>
                Previous
              </button>
            )}
            {currentStep < totalSteps - 1 ? (
              <button className="btn next-button" onClick={nextStep}>
                Next
              </button>
            ) : (
              <button className="btn next-button" onClick={onFinish}>
                Finish Tour
              </button>
            )}
          </div>
        </Modal.Footer>
      )}
    </Modal>
  );
};

export default WelcomeTour;